import { client } from 'pioneira-ui';

export default {
  namespaced: true,
  actions: {
    getEmpresaByCnpj(context, cnpj) {
      return client.get(`/api/listas/empresas?cnpj=${cnpj}`);
    },
  },
};
